import { render, staticRenderFns } from "./TableLabAux.vue?vue&type=template&id=5dee34e7&scoped=true"
import script from "./TableLabAux.vue?vue&type=script&lang=js"
export * from "./TableLabAux.vue?vue&type=script&lang=js"
import style0 from "./TableLabAux.vue?vue&type=style&index=0&id=5dee34e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dee34e7",
  null
  
)

export default component.exports